import React from "react";
import { createPortal } from "react-dom";
import { SVGIcon } from "@pearsontechnology/aero-components-v2";
import { NODE_TYPE_FOOTNOTE } from "./constants";
import { FootnoteWrapper } from "./styles";
import { withInlineVoidElement } from "../../utils";
import {
  usePopover,
  PopoverWrapper,
  CloseButton,
  PopoverContent,
  PopoverStageContent,
  PopoverBreakOpportunity,
} from "../common";

export default function Footnote() {
  const plugin = (editor: any) => {
    withInlineVoidElement(editor, NODE_TYPE_FOOTNOTE);
    return editor;
  };

  plugin.renderElement = ({ element, attributes, children }: any) => {
    if (element.type !== NODE_TYPE_FOOTNOTE) {
      return undefined;
    }

    // Extract footnote marker text from node.nodes (the children)
    // const markerText = getTextFromNodes(element.children || []);

    // Extract stage from nested data structure
    const data = element.data;
    const stage = data?.stage;

    // Get footnote ID from ref, dataId, or generate from node key
    const ref = data?.ref || stage?.ref;
    const dataId = data?.dataId;
    const footnoteId = ref || dataId;

    return (
      <FootnoteComponent {...attributes} stage={stage} footnoteId={footnoteId} dataKey={dataId}>
        {children}
      </FootnoteComponent>
    );
  };

  return plugin;
}
interface FootnoteComponentProps {
  marker?: string;
  stage: any;
  footnoteId: string;
  dataKey?: string | number;
  children: React.ReactNode;
  [key: string]: any;
}

const FootnoteComponent: React.FC<FootnoteComponentProps> = ({
  stage,
  footnoteId,
  dataKey,
  children,
  ...attributes
}) => {
  const {
    showPopover,
    hasYOverflow,
    arrowXOffset,
    wrapperRef,
    popoverRef,
    closeButtonRef,
    handleClick,
    handleClose,
    handleKeyDown,
  } = usePopover();

  return (
    <>
      <FootnoteWrapper
        {...attributes}
        ref={wrapperRef as React.RefObject<HTMLAnchorElement>}
        href="#"
        data-footnote-id={footnoteId}
        onClick={handleClick}
        role="button"
        tabIndex={0}
        aria-expanded={showPopover}
        aria-haspopup="dialog"
        onKeyDown={handleKeyDown}
      >
        <span>{children}</span>
      </FootnoteWrapper>
      <PopoverBreakOpportunity aria-hidden="true" />
      {showPopover &&
        createPortal(
          <PopoverWrapper
            ref={popoverRef}
            id={footnoteId}
            {...({ type: "footnote", "data-key": String(dataKey) } as any)}
            className="popover-wrapper foot-note"
            role="dialog"
            aria-modal="true"
            aria-labelledby={`${footnoteId}-title`}
            tabIndex={-1}
            isOpen={showPopover}
            hasYOverflow={hasYOverflow}
            arrowXOffset={arrowXOffset}
          >
            <CloseButton
              onClick={handleClose}
              aria-label="Close"
              className="popover-close-btn"
              type="button"
              tabIndex={0}
              ref={closeButtonRef}
            >
              <SVGIcon icon="closeX" />
            </CloseButton>
            <PopoverContent>
              {stage ? <PopoverStageContent stage={stage} /> : <div>Content not available</div>}
            </PopoverContent>
          </PopoverWrapper>,
          document.getElementById("viewer-express-container") ?? document.body,
        )}
    </>
  );
};
